import React from 'react';
import { RotateCcw, Globe } from 'lucide-react';
import { useCompactViewport } from '../../../hooks/useCompactViewport';

const disabledClass = 'disabled:cursor-not-allowed disabled:opacity-50';

const MapControls = ({ onReset, onOpenCountries, showCountriesLauncher, disabled = false }) => {
  const isCompact = useCompactViewport();

  return (
    <div className="absolute bottom-4 left-4 z-30 flex flex-row flex-wrap gap-2">
      {showCountriesLauncher && onOpenCountries && (
        <button
          type="button"
          onClick={onOpenCountries}
          disabled={disabled}
          className={`map-control-btn flex items-center space-x-2 px-4 py-2 text-sm font-medium ${disabledClass}`}
        >
          <Globe className="h-4 w-4" />
          <span>Countries</span>
        </button>
      )}
      {!isCompact && onReset && (
        <button
          type="button"
          onClick={onReset}
          disabled={disabled}
          className={`map-control-btn flex items-center space-x-2 px-4 py-2 text-sm font-medium ${disabledClass}`}
        >
          <RotateCcw className="h-4 w-4" />
          <span>Reset</span>
        </button>
      )}
    </div>
  );
};

export default React.memo(MapControls);
